const defaultState = {
  userLocations: null,
  error: null,
  fetching: false,
  fetched: false,
  saved: false
};

const getCustomerWithLocationsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'USER_LOCATIONS_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true
      };
    }
    case 'USER_LOCATIONS_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, userLocations: action.payload.data
      };
    }
    case 'USER_LOCATIONS_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        userLocations: null,
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default getCustomerWithLocationsReducer;


// WEBPACK FOOTER //
// ./src/reducers/getUserLocations.js